// src/components/DealerAccount.js
import React, { useState, useEffect, useContext } from 'react';
import { Box, Button, Grid, IconButton, Paper, Typography } from '@mui/material';
import '../assets/css/NavBar.css';
import { getDealerCompany } from '../services/APIServices';
import { UserContext } from '../contexts/UserContext';
import EditIcon from '@mui/icons-material/Edit';
import { Spinner } from './Spinner';
import DealerModal from './DealerDetailModal';
import { useNavigate } from 'react-router-dom';

const DealerAccount = () => {
  const navigate = useNavigate();
  const { company, setCompany, user, token } = useContext(UserContext);
  const [loaded, setLoaded] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [displayCompanyDetails, setDisplayCompanyDetails] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const dealerID = user.DealerID;

      setLoaded(true);
      try {
        const res = await getDealerCompany(dealerID, token);
        setCompany(res.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoaded(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const propertiesToDisplay = ['CompanyName', 'TraderNumber', 'TradingName', 'LogoURL', 'Address', 'ContactPerson', 'ContactNumber', 'Website', 'DealerTerms'];
    const displayFormat = { CompanyName: 'Company Name', TraderNumber: 'Trader Number', TradingName: 'Trading Name', LogoURL: 'Logo URL', Address: 'Dealer Address', ContactPerson: 'Contact Person', ContactNumber: 'Contact Number', Website: 'Dealer Website', DealerTerms: 'Dealer Terms' };
    const result = propertiesToDisplay.map(property => ({
      name: displayFormat[property],
      value: company[property] || 'N/A'
    }));
    setDisplayCompanyDetails(result);
  }, [company]);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleBrandingPageOpen = () => {
    navigate('/dealer-branding');
  };
  return (
    <>
      {loaded ? (<div className="middle"><Spinner></Spinner></div>) : (
        <>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={8} sx={{ mt: { xs: 3, sm: 6 }, px: { xs: 2, sm: 0 }, minWidth: 0 }}>
              <Paper
                elevation={0}
                sx={{
                  border: '1px solid #c52b2b',
                  borderRadius: 2,
                  overflow: 'hidden',
                  backgroundColor: '#ffffff'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    justifyContent: 'space-between',
                    px: { xs: 2, sm: 3 },
                    py: { xs: 1.5, sm: 2 },
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2,
                    backgroundColor: '#c52b2b',
                    color: '#c52b2b',
                  }}
                >
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#ffffff' }}>
                      Dealer Account
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                      Company profile and contact details
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: { xs: '100%', sm: 'auto' } }}>
                    <Button
                      variant="contained"
                      onClick={handleBrandingPageOpen}
                      sx={{
                        backgroundColor: '#ffffff',
                        color: '#c52b2b',
                        border: '1px solid #ffffff',
                        fontWeight: 700,
                        width: { xs: '100%', sm: 'auto' },
                        '&:hover': { backgroundColor: '#f7dede', borderColor: '#f7dede' }
                      }}
                    >
                      Branding
                    </Button>
                    <IconButton
                      onClick={handleModalOpen}
                      sx={{
                        color: '#c52b2b',
                        backgroundColor: '#ffffff',
                        '&:hover': { backgroundColor: '#f7dede' }
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                    <DealerModal open={modalOpen} handleClose={handleModalClose} />
                  </Box>
                </Box>
                <Box sx={{ p: 3 }}>
                  <Grid container spacing={2}>
                    {displayCompanyDetails.map((detail) => (
                      <Grid item xs={12} md={6} key={detail.name}>
                        <Box
                          sx={{
                            border: '1px solid #f0f0f0',
                            borderRadius: 1.5,
                            p: 2,
                            backgroundColor: '#ffffff'
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              color: '#c52b2b',
                              fontWeight: 700,
                              textTransform: 'uppercase',
                              letterSpacing: '0.08em'
                            }}
                          >
                            {detail.name}
                          </Typography>
                          <Typography variant="body1" sx={{ color: '#111111', mt: 0.5, overflowWrap: 'break-word' }}>
                            {detail.value}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default DealerAccount;
